'use strict';

angular.module('docketbook')
.controller('addressBookTagController', function($scope, addressBookService, Restangular, $state, $window, $stateParams, accessControl, $q) {
  mixpanel.track("Opened CompanySettings-AddressBookTags Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();

  $scope.selected = [];
  $scope.allTags = [];

  $scope.loadTagList = function() {
    $scope.loadPromise = $q(function(resolve, reject) {
      addressBookService.getAddressBookTags({}, function(results){
        $scope.allTags = results.map((tag) => {
          return Object.assign({
            editing: false
          }, tag)
        });
        resolve($scope.allTags)
      }, function(err){
        $scope.allTags = [];
        reject('Error');
      })
    })
  }

  $scope.deleteSelectedTags = function() {
    const promises = $scope.selected.map((item) => {
      return $q(function(resolve, reject) {
        addressBookService.deleteAddressBookTag(item, function(){
          resolve();
        }, function(err){
          reject(err);
        })
      })
    })
    $q.all(promises).then(() => {
      $scope.loadTagList();
    }).catch((err) => {
      $scope.loadTagList();
    })
  }

  $scope.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  $scope.insertNewTag = function() {
    $scope.allTags.splice(0, 0, {
      tag: "",
      description: "",
      editing: true
    });
  }

  $scope.saveTagRow = function(tag) {
    addressBookService.saveAddressBookTag(tag, function(results){
      $scope.loadTagList();
    }, function(err) {
      reject('Error');
    })
  }

  $scope.editTagRow = function(tag) {
    tag.editing = true;
  }

  $scope.loadTagList();

});



// WEBPACK FOOTER //
// ./src/controllers/companySettings/addressBookTags.js